import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { getIsUserSignedIn } from "@gamedev-web/gamedev-sdk-core";
import { useString } from "../../localization/localizationHelpers";
import { AaaIntroContactDataType, AaaIntroStudioDataType } from "../../models/forms";
import { RouteNames } from "../../partnerConfig/routeNames";
import { OnboardingUrls } from "../../partnerConfig/routes";
import { OnboardingRootState } from "../../redux/reducers/rootReducer";
import { getSubFormData } from "../../redux/selectors";
import {
  AaaContactStudioFormId,
  AaaContactStudioSubFormsId,
} from "../AaaDashboardPage/AaaContactFormConstants";
import { FormPreview } from "./FormPreview";
import { FormPreviewValidDataType, ReadOnlyFormId } from "./ReadOnlyForms";

export const AaaCompanyInformationFormPreview = () => {
  const companyInformation = useString("companyInformation");
  const isSignedIn = useSelector(getIsUserSignedIn);
  const history = useHistory();

  const introContactSubFormData = useSelector((state: OnboardingRootState) =>
    getSubFormData(state, AaaContactStudioFormId, AaaContactStudioSubFormsId.ContactInformation)
  ) as AaaIntroContactDataType;

  const introStudioSubFormData = useSelector((state: OnboardingRootState) =>
    getSubFormData(state, AaaContactStudioFormId, AaaContactStudioSubFormsId.StudioInformation)
  ) as AaaIntroStudioDataType;

  useEffect(() => {
    if (!isSignedIn) {
      history.replace(OnboardingUrls[RouteNames.AaaWelcome]);
    }
  }, [isSignedIn, history]);

  const readOnlyForms = new Map<ReadOnlyFormId, FormPreviewValidDataType>([
    [ReadOnlyFormId.AaaStudioInformation, introStudioSubFormData],
    [ReadOnlyFormId.AaaContactInformation, introContactSubFormData],
  ]);

  return <FormPreview title={companyInformation} readOnlyForms={readOnlyForms} />;
};
